import { render, staticRenderFns } from "./SHHeader.vue?vue&type=template&id=8c83ba74&scoped=true"
import script from "./SHHeader.vue?vue&type=script&lang=ts"
export * from "./SHHeader.vue?vue&type=script&lang=ts"
import style0 from "./SHHeader.vue?vue&type=style&index=0&id=8c83ba74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c83ba74",
  null
  
)

export default component.exports